import {Box, Button, Container, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import {sendEmailVerification} from "firebase/auth";
import {FirebaseError} from "firebase/app";
import FactoringTable from "./FactoringTable";
import FactoringNotification from "./FactoringNotification";
import {useAuthenticatedUser} from "../../../AuthProvider";
import {EmailVerificationNotice} from "./EmailVerificationNotice";
import {useUserPermissions} from "components/useUserPermissions";
import {CompanyName} from "components/CompanyName";

export default function MyPage() {
  const user = useAuthenticatedUser();
  const navigate = useNavigate();

  const {
    isShowDetailRegister,
    isShowFactoringEntry,
    isShowEmailVerificationOnly,
    isRegisteredButNotApproved,
  } = useUserPermissions();

  const handleSendVerification = async () => {
    if (!confirm(`${user.email} 宛に確認メールを再送信しますか？`)) {
      return;
    }
    try {
      await sendEmailVerification(user);
      alert(
        "確認メールを送信しました。メール内のリンクをクリックして確認を完了してください。",
      );
    } catch (error) {
      console.error("確認メール送信エラー:", error);

      if (error instanceof FirebaseError) {
        switch (error.code) {
          case 'auth/too-many-requests':
            alert(
              "確認メールの送信回数が上限に達しました。しばらく時間をおいてから再度お試しください。",
            );
            break;
          case 'auth/user-disabled':
            alert(
              "このアカウントは無効になっています。サポートにお問い合わせください。",
            );
            break;
          case 'auth/user-not-found':
            alert(
              "ユーザーが見つかりません。再度ログインしてお試しください。",
            );
            break;
          case 'auth/invalid-user-token':
          case 'auth/user-token-expired':
            alert(
              "認証の有効期限が切れています。再度ログインしてお試しください。",
            );
            break;
          case 'auth/network-request-failed':
            alert(
              "ネットワークエラーが発生しました。インターネット接続を確認して再度お試しください。",
            );
            break;
          case 'auth/internal-error':
            alert(
              "システム内部エラーが発生しました。しばらく経ってから再度お試しください。",
            );
            break;
          default:
            alert(
              "確認メールの送信に失敗しました。しばらく経ってからお試しください。",
            );
            break;
        }

      } else {
        alert(
          "確認メールの送信に失敗しました。しばらく経ってからお試しください。",
        );
      }
    }
  };

  return (
    <Container
      component="main"
      maxWidth="md"
      sx={{
        mt: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <CompanyName withHonorific={true} hideIfEmpty={true} />
      <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
        マイページ
      </Typography>

      {isShowEmailVerificationOnly &&
        <EmailVerificationNotice onClick={handleSendVerification} />
      }

      {/* 登録済みだが未承認のユーザーへのメッセージ */}
      {isRegisteredButNotApproved &&
        <Box
          sx={{
            width: "100%",
            mb: 4,
            p: 2,
            borderRadius: 1,
          }}
        >
          <Typography variant="body1" align="center">
            本会員承認まで今しばらくお待ちください。
          </Typography>
        </Box>
      }

      {/* ファクタリングのお知らせを表示 */}
      {isShowFactoringEntry &&
        <FactoringNotification />
      }

      {/* 会員詳細情報登録エリア */}
      {isShowDetailRegister &&
        <Box
          sx={{
            width: "100%",
            mb: 4,
            display: "flex",
            flexDirection: { xs: "column" },
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ maxWidth: { sm: 200 } }}
            style={{ marginLeft: "auto", marginRight: "auto" }}
            onClick={() => navigate("/mypage/detail/register")}
          >
            会員詳細情報登録
          </Button>
          <Typography
            variant="body2"
            color="warning.main"
            sx={{mt: 1, textAlign: "center"}}
          >
            ※ファクタリングの申込には会員詳細情報の登録が必要です
          </Typography>
        </Box>
      }

      {/* ファクタリングエリア */}
      {isShowFactoringEntry &&
        <>
          <Box
            sx={{
              width: "100%",
              mb: 4,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ maxWidth: { sm: 200 } }}
              onClick={() => navigate("/factoring/entry", { state: { from: "mypage" } })}
            >
              ファクタリング申込
            </Button>
          </Box>

          <Box sx={{ width: "100%", mt: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              申込一覧
            </Typography>

            <FactoringTable />
          </Box>
        </>
      }
    </Container>
  );
}
